import { render } from "./GestaoEpis.vue?vue&type=template&id=6ce43e9f&scoped=true"
import script from "./GestaoEpis.vue?vue&type=script&lang=js"
export * from "./GestaoEpis.vue?vue&type=script&lang=js"

import "./GestaoEpis.vue?vue&type=style&index=0&id=6ce43e9f&scoped=true&lang=css"
import "./GestaoEpis.vue?vue&type=style&index=1&id=6ce43e9f&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce43e9f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn,QSelect,QTooltip,QItem,QItemSection,QField});
